import React, { useEffect } from "react";

export default function Nodata() {

  useEffect(() => { 
      console.log('render NoData')
  }); 

  return (
      <div>
        <br />
        <br />
        <br />
        <h1> Update of the metrics in progress </h1>
      </div>
    )
}